import './Editor.css';
import Bar from './Bar/Bar';
import Panzone from './Camera/Camera';
import EditorWindow from './EditorWindow/EditorWindow';
import editorAction from '../actions/editorAction';
import Popup from './Popup/Popup';
import EditorContextProvider from '../contexts/EditorContext';
import { useEffect, useState } from 'react';
import { useToastDispatchContext } from '/src/layouts/toast/context/toastContext';
import { useLocation } from 'react-router-dom';
import { useParams } from "react-router-dom";
import { launchFireworks } from "/src/components/fireworks/firework";
import { useNavigate } from "react-router-dom";
function Editor({ bot }) {

    const location = useLocation();
    const navigate = useNavigate(); 

    const searchParams = new URLSearchParams(location.search);
    const fromCreated = searchParams.get('fromCreated'); // Récupère la valeur du paramètre 'fromCreated'
    const { actionGetBotInformations } = editorAction();
    const toast = useToastDispatchContext()
    const [toastData, setToastData] = useState(null);
    const [loadConfetis, setLoadConfetis] = useState(fromCreated == "true");
    // get the name of the from the url and fetch it's data

    useEffect(() => {
        let isBotInfo = true;

        const fetchData = async () => {
            const result = await actionGetBotInformations(bot);
            if (!result) return;
            setToastData(toast.error('Bot not find', result.data, 3000, 0))
        }

        fetchData().catch((err) => {
            console.error(err)
        });

        return () => {
            isBotInfo = false;
        }
    }, [bot]);

    useEffect(() => {
        return () => {
            if (toastData == null) return;
            toast.dispatch({ type: 'deleteToast', payload: { id: toastData.id } });
            setToastData(null)
        }
    }, [bot, toastData])

    useEffect(() => {
        if (loadConfetis == true) {
            setLoadConfetis(false);
            launchFireworks();
            setTimeout(() => {
                searchParams.delete('fromCreated'); // on retire le parametre pour ne pas remettre les confetis une 2nde fois
                navigate({ search: searchParams.toString() }, { replace: true });
              }, 1000); 
        }
    }, [loadConfetis])

    // BotEditor required Bar component to make custom like import scenario, multiple block selection
    // Panzone components is required to move blocks and paths
    // Declare EditorWindow and Popup for calling them latter thanks to @ebay/nice-modal
    // They handled the form block's modification
    return (
        <div className="bot-editor">
            <div id="firework-container"></div>
            <EditorContextProvider>
                <Bar />
                <Panzone />
            </EditorContextProvider>
            <EditorWindow id='editor-window' />
            <Popup id='editor-popup' />
        </div>
    )
}

export default Editor;